module.exports = __webpack_public_path__ + "img/m-wash3prousa_5-back.d4f71336.jpg";